import api from "../utils/axios";

export const adminApi = {
    // User Management
    getAllUsers: () => api.get("/users/admin/users/"),
    createUser: (data) => api.post("/users/admin/users/create/", data),
    getSingleUser: (id) => api.get(`/users/admin/users/${id}/`),
    updateUser: (id, data) => api.put(`/users/admin/users/${id}/update/`, data),
    deleteUser: (id) => api.delete(`/users/admin/users/${id}/delete/`),

    // Invoice Management
    getAllInvoices: () => api.get("/documents/admin/invoices/"),
    createInvoices: (data) => api.post("/documents/admin/invoices/create/", data),
    getSingleInvoices: (id) => api.get(`/documents/admin/invoices/${id}/`),
    updateInvoices: (id, data) => api.put(`/documents/admin/invoices/${id}/update/`, data),
    deleteInvoices: (id) => api.delete(`/documents/admin/invoices/${id}/delete/`),
};
